/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Layout from "../../../Layouts/Layout";
import { Helmet } from "react-helmet-async";
import CheckoutConfirmation from "../../../HigherOrderContainers/CheckoutConfirmation";

const PaidPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>Zahlung erfolgreich | Legalbird</title>
      </Helmet>
      <CheckoutConfirmation />
    </Layout>
  );
};

export default PaidPage;
